export default "__VITE_ASSET__2d203acd__"